import { NotFoundError } from '../../../../errors/not-found-error';
import { EpisodeAsset, MovieAsset, ProgramAsset } from '../../../../queries/ats/titles/types/asset';
import { VodSource } from '../../../../queries/ats/titles/types/sources';
import { routes } from '../../../../routes/route-utils';
import { createContexts } from '../../../../views/ats-details/use-available-contexts';
import { getPreferredSource } from '../../../../views/ats-details/utils';

export function getPreferredProgramSource(episode: EpisodeAsset | MovieAsset | ProgramAsset) {
  const contexts = createContexts(episode);
  const tvContext = contexts.find((x) => x.type === 'tv');

  if (tvContext === undefined) {
    throw new NotFoundError('No vod context found.');
  }

  const source = getPreferredSource(episode.sources, tvContext, {
    platformTitleId: undefined,
    orderByProviderId: undefined,
    orderByServiceType: 'vod',
  });

  if (source.type !== 'program') {
    throw new NotFoundError('No vod source found.');
  }

  return source;
}

export function getSourcePath(source: VodSource) {
  const route = routes.play({ platformTitleId: source.platformTitleId, position: 0 });
  return {
    pathname: route.pathname,
    search: route.search,
  };
}
